<template>
<div >
 
<va-card>
<p class="display-3 text-center"> {{$t('arealuno.Inscricao')}}  {{get_dados_disciplina.nome_curso}} </p>
<hr>

  <div class="flex">
          <form class="flex " @submit.prevent="addNovo()">
            
             <h5>{{$t('arealuno.Dados_pessoais')}}</h5>
              <hr>
              <div class="row">
                <div class="flex md3 sm12 xs12">
                  <va-input
                    class="espaco"
                   :label=" $t('arealuno.Nome')+ ' *'"
                    v-model="aluno.nome"
                    :placeholder="$t('arealuno.Nome')"
                    :error="!!nomeErrors.length"
                    :error-messages="nomeErrors"
                  />
                </div>

                <div class="flex md4 sm12 xs12">
                  <va-input
                  class="espaco"
                  :label="$t('arealuno.Sobrenome')+ ' *'"
                    v-model="aluno.sobrenome"
                    :placeholder="$t('arealuno.Sobrenome')"
                    :error="!!sobrenomeErrors.length"
                    :error-messages="sobrenomeErrors"
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                    <va-select
                    class="espaco"
                      label="Tipo documento *"
                      v-model="aluno.tipo_documento"
                      textBy="nome"
                      :options="allTipoDocumento"
                      placeholder="Tipo documento"
                      :error="!!tipodocumentoErrors.length"
                      :error-messages="tipodocumentoErrors"
                    />
                  </div>
                <div class="flex md2 sm12 xs12">
                  <va-input
                  class="espaco"
                   label="Documento *"
                    v-model="aluno.doc_oficial"
                    placeholder="Documento"
                    :error="!!documentoErrors.length"
                    :error-messages="documentoErrors"
                  />
                </div>
              </div>

               <h5>{{$t('arealuno.Dados_domicilio')}}</h5>
              <hr>

              <div class="row">
                <div class="flex md3 sm12 xs12">
                  <va-input
                  class="espaco"
                  :label="$t('arealuno.Rua')"
                    v-model="aluno.endereco"
                    :placeholder="$t('arealuno.Rua')"
                   
                  />
                </div>

                <div class="flex md3 sm12 xs12">
                  <va-input
                  class="espaco"
                  :label="$t('arealuno.Numero')"
                    v-model="aluno.numero"
                    placeholder="Numero"
                    
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input
                  class="espaco"
                  :label="$t('arealuno.Bairro')"
                    v-model="aluno.bairro"
                    :placeholder="$t('arealuno.Bairro')"
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input
                  class="espaco"
                  :label="$t('arealuno.Codigo_postal')"
                    v-model="aluno.cep"
                    :placeholder="$t('arealuno.Codigo_postal')"
                  />
                </div>

                  
              </div>

              <div class="row">

                <div class="flex md2 sm12 xs12">
                    <va-select
                      class="espaco"
                      label="País *"
                      v-model="aluno.pais_endereco"
                      textBy="nome"
                      :options="allPais"
                      placeholder="País"
                  
                    />
                  </div>
                
                  <div class="flex md2 sm12 xs12">
                    <va-select
                    class="espaco"
                      label="Estado *"
                      v-model="aluno.estado_endereco"
                      textBy="nome"
                      :options="AllEstadoEndereco"
                      placeholder="Estado"
                     
                    />
                  </div>
                  <div class="flex md2 sm12 xs12">
                    <va-select
                    class="espaco"
                     :label="$t('arealuno.Cidade')+ ' *'"
                      v-model="aluno.cidade"
                      textBy="nome"
                      :options="AllCidadeEndereco"
                      :placeholder="$t('arealuno.Cidade')"
                      :error="!!cidadeErrors.length"
                      :error-messages="cidadeErrors"
                    />
                  </div>

                  <div class="flex md3 sm12 xs12">
                    <va-select
                    class="espaco"
                      :label="$t('arealuno.Referencia')+ ' *'"
                      v-model="aluno.polo"
                      textBy="nome"
                      :options="allPolos"
                      placeholder="Referencia"
                     
                    />
                  </div>

                  <div class="flex md3 sm12 xs12">
                    <va-select
                    class="espaco"
                      :label="'Curso'+ ' *'"
                      v-model="aluno.ofertaGradePolo"
                      textBy="nome_curso"
                      :options="AllCursosLiberadosPolo"
                      placeholder="Curso"
                      :error="!!cursoErrors.length"
                      :error-messages="cursoErrors"
                    />
                  </div>

              </div>

              <h5>{{$t('arealuno.Outros')}}</h5>
              <hr>
            
              <div class="row">
                <div class="flex md3 sm12 xs12">
                
              
                  <va-input v-if="pais_se == '4'"
                  
                  class="espaco"
                  v-mask="'+55 (##) ####-####'"
                  
                  :label="$t('arealuno.Telefone')"
                  v-model="aluno.telefone"
                  :placeholder="$t('arealuno.Telefone')"
                  
                  />

                  <va-input v-if="pais_se == '3'"
                  
                  class="espaco"
                  v-mask="'+595 (##) ###-####'"
                
                  :label="$t('arealuno.Telefone')"
                  v-model="aluno.telefone"
                  :placeholder="$t('arealuno.Telefone')"
                  
                  />
            
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input v-if="pais_se == '4'"
                   v-mask="'+55 (##) # ####-####'"
                  class="espaco"
                   label="Celular"
                    v-model="aluno.celular"
                    placeholder="Celular"
                    
                  />

                   <va-input v-if="pais_se == '3'"
                   v-mask="'+595 (###) ###-####'"
                  class="espaco"
                   label="Celular"
                    v-model="aluno.celular"
                    placeholder="Celular"
                    
                  />

                </div>
                 
                  <div class="flex md3 sm12 xs12">
                  <va-input
                  class="espaco"
                   label="Email *"
                    v-model="aluno.email"
                    type="email"
                    placeholder="Email"
                    :error="!!emailErrors.length"
                    :error-messages="emailErrors"
                  />
                </div>
                 <div class="flex md3 sm12 xs12">
                  <va-input
                  class="espaco"
                  :label="$t('arealuno.Data_nacimento')+ ' *'"
                    v-model="aluno.data_nascimento"
                    type="date"
                    :placeholder="$t('arealuno.Data_nacimento')"
                    :error="!!datanascimentoErrors.length"
                    :error-messages="datanascimentoErrors"
                  />
                </div>
              </div>
              
              <div class="row">
                  <div class="flex md3 sm12 xs12">
                    <va-input
                    class="espaco"
                    :label="$t('arealuno.Profissao')"
                      v-model="aluno.nome_profissao"
                      type="text"
                      :placeholder="$t('arealuno.Profissao')"
                    />
                  </div>

                  <div class="flex md3 sm12 xs12">
                    <va-input
                    class="espaco"
                    :label="$t('arealuno.Escolaridade')"
                      v-model="aluno.nome_escolaridade"
                      type="text"
                      :placeholder="$t('arealuno.Escolaridade')"
                      
                    />
                  </div>
                
                  <div class="flex md3 sm12 xs12">
                    <va-select
                    class="espaco"
                      label="Sexo *"
                      v-model="aluno.sexo"
                      textBy="nome"
                      :options="allSexo"
                      placeholder="Sexo"
                      :error="!!sexoErrors.length"
                      :error-messages="sexoErrors"
                    />
                  </div>
                  <div class="flex md3 sm12 xs12">
                    <va-select
                    class="espaco"
                      label="Estado civil *"
                      v-model="aluno.estado_civil"
                      textBy="nome"
                      :options="allEstadoCivil"
                      placeholder="Estado civil"
                      :error="!!estadocivilErrors.length"
                      :error-messages="estadocivilErrors"
                    />
                  </div>

              </div>
              
              <h5>{{$t('arealuno.Dados_nacimento')}}</h5>
              <hr>
              <div class="row">
                
                  <div class="flex md2 sm12 xs12">
                    <va-select
                    class="espaco"
                      label="País *"
                      v-model="aluno.pais_naturalidade"
                      textBy="nome"
                      :options="allPais"
                      placeholder="País"
                      
                      
                    />
                  </div>
                
                  <div class="flex md3 sm12 xs12">
                    <va-select
                    class="espaco"
                      label="Estado *"
                       v-model="aluno.estado_naturalidade"
                      textBy="nome"
                      :options="AllEstadoNaturalidade"
                      placeholder="Estado"
                   
                    />
                  </div>
                  <div class="flex md3 sm12 xs12">
                    <va-select
                    class="espaco"
                      :label="$t('arealuno.Cidade')"
                      v-model="aluno.naturalidade"
                      textBy="nome"
                      :options="AllCidadeNaturalidade"
                      :placeholder="$t('arealuno.Cidade')"
                      :error="!!nacidadeErrors.length"
                      :error-messages="nacidadeErrors"
                    />
                  </div>
                  <!-- <div class="flex md4 sm12 xs12">
                    <va-select
                      :label="'Selecione o curso que deseja'"
                      v-model="aluno.grade_curricular"
                      textBy="nome_curso"
                      :options="getGradeCurricular"
                      placeholder="Selecione o Curso"
                      :error="!!cursoErrors.length"
                      :error-messages="cursoErrors"
                    />
                  </div> -->
             
              </div>
              <div class="row text-center">
                
                 <div class="flex md12 sm12 xs12 text-center">
                    <va-button class="text-center"   color="dark"> Enviar </va-button>
                </div>

              </div>
              
          </form>

  </div>

</va-card>


</div>

      
 
</template>



<script>
import {mask} from 'vue-the-mask'


export default {
  directives: {mask},
  name: 'formulario',
  
  components: {
  
  },


  data () {
      return {
        
        BuNovo: {
          color:'success',
          'width': '100%',
        }, 
        novo: false,
        grade_id:'',

        cidade_naturalidade:[],
        cidade_endereco:[],
   
        aluno:{
          nome:'',
          sobrenome:'',
          tipo_documento:'',
          doc_oficial:'',
          telefone:'',
          celular:'',
          email:'',
          data_nascimento:'',
          profissao:'',
          escolaridade:'',
          sexo:'',
          estado_civil:'',
          endereco:'',
          numero:'',
          bairro:'',
          cep:'',
          nome_escolaridade:'',
          nome_profissao:'',
          cidade:'',
          grade_curricular:this.$store.state.informacao.infoGrade ,
          pais:'',
          naturalidade:'',
          perfil_id: '2',
          polo_id:'',
          
          curso: {
            id:'',
          },
          pais_naturalidade: {
            id:'',
          },
          estado_naturalidade:{
            id:'',
          },
          pais_endereco: {
            id:'',
          },
          estado_endereco:{
            id:'',
          },
          polo:{
            id:'',
          },
          ofertaGradePolo:{
            id:'',
          },

        },
        cidade:[],
        estado:[],
        pais:[],

        emailErrors: [],
        poloErrors: [],
        nomeErrors: [],
        sobrenomeErrors: [],
        tipodocumentoErrors: [],
        estadocivilErrors: [],
        documentoErrors: [],
        datanascimentoErrors: [],
        profissaoErrors: [],
        escolaridadeErrors: [],
        sexoErrors: [],
        //enderecoErrors: [],
        paisErrors: [],
        cidadeErrors: [],
        estadoErrors: [],
        napaisErrors: [],
        nacidadeErrors: [],
        naestadoErrors: [],
        cursoErrors:[],

    
     
      }
    },
    created(){
      this.buscar_tipos()
     
    },
   
  computed: {

    pais_se(){
      let valor
       if(this.aluno.estado_endereco.pais_id == null){
         return  valor = '3'
       }else{
         return this.aluno.estado_endereco.pais_id
       }


    },
    get_dados_disciplina(){
      return this.$store.state.informacao.infoGrade
    },
      
    
    
    getGradeCurricular (){
        return  this.$store.state.gradecurricular.gradecurricular   
        
    },
    allTipoDocumento(){ 

      let tipo_documento_pt = [{id:2,nome:'RG'}]
      let tipo_documento_es = [{id:2,nome:'Cédula de Identidad'}]
      
        if(this.$t('arealuno.Idioma') == 'es'){
          this.aluno.tipo_documento = ''
            return tipo_documento_es
           
         }
        if(this.$t('arealuno.Idioma') == 'pt'){
          this.aluno.tipo_documento = ''
            return tipo_documento_pt
         }


    
    
    },
    allProfissao(){ return   this.$store.state.tipos.profissao},
    allEscolaridade(){ return   this.$store.state.tipos.escolaridade},
    allSexo(){ return   this.$store.state.tipos.sexo},
    allEstadoCivil(){ return   this.$store.state.tipos.estado_civil},
    allPais(){ return   this.$store.state.tipos.pais},
    allPolos(){ return   this.$store.state.polos.allpolos},
    

     AllCursosLiberadosPolo(){ 
        if (this.aluno.polo.id != '') {
           this.$store.dispatch('cursosOfertaPolo',this.aluno.polo.id)
           this.aluno.polo_id = this.aluno.polo.id
           this.aluno.polo.id = ''

        }
       return this.$store.state.polos.polosselecionados
    },

    AllEstadoNaturalidade(){ 
        if (this.aluno.pais_naturalidade.id != '') {
          this.$store.dispatch('GetEstadoNaturalidade',this.aluno.pais_naturalidade.id)
          this.aluno.pais_naturalidade.id = ''
        }
        return this.$store.state.tipos.estado_naturalidade 
    },
    AllCidadeNaturalidade(){ 
        if (this.aluno.estado_naturalidade.id != '') {
          this.$store.dispatch('GetCidadeNaturalidade',this.aluno.estado_naturalidade.id)
          this.aluno.estado_naturalidade.id = ''
        
        }
        return this.$store.state.tipos.cidade_naturalidade 
    },
    AllEstadoEndereco(){ 
        if (this.aluno.pais_endereco.id != '') {
          this.$store.dispatch('GetEstadoEndereco',this.aluno.pais_endereco.id)
          this.aluno.pais_endereco.id = ''
        
        }
        return this.$store.state.tipos.estado_endereco
    },
    AllCidadeEndereco(){ 
        if (this.aluno.estado_endereco.id != '') {
          this.$store.dispatch('GetCidadeEndereco',this.aluno.estado_endereco.id)
          this.aluno.estado_endereco.id = ''
        }
        return this.$store.state.tipos.cidade_endereco
    },
  
   
    
    fields () {
        return [{
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        }, {
          name:'nome',
          title: this.$t('tables.headings.name'),
        }, {
          name: 'email',
          title: this.$t('tables.headings.email'),
        }, {
          name: 'country',
          title: this.$t('tables.headings.country'),
        },{
          name: 'acion',
          dataClass: 'text-right',
          title: this.$t('tables.headings.country'),
         
        }, {
          name: '__slot:actions',
          dataClass: 'text-right',
        }]
    },
  formReady () {
      return !this.emailErrors.length
      return !this.poloErrors.length
      return !this.nomeErrors.length
      return !this.sobrenomeErrors.length
      return !this.tipodocumentoErrors.length
      return !this.estadocivilErrors.length
      return !this.documentoErrors.length
      return !this.datanascimentoErrors.length
      return !this.profissaoErrors.length
      return !this.escolaridadeErrors.length
      return !this.sexoErrors.length
      //return !this.enderecoErrors.length
      return !this.cidadeErrors.length
      return !this.nacidadeErrors.length
      return !this.cursoErrors.length

    },
         
  },

  methods: {
    buscar_tipos(){
      this.$store.dispatch('allTipoDocumento')
      this.$store.dispatch('allProfissao')
      this.$store.dispatch('allEscolaridade')
      this.$store.dispatch('allSexo')
      this.$store.dispatch('allEstadoCivil')
      this.$store.dispatch('allPais')
      this.$store.dispatch('allPolo')
       
    },
    async abrirMatriculaAluno (value) {
     
      this.$store.dispatch('getAluno',value);
      this.$emit('trocar_component', 'matriculaaluno');
      
      },

    abrirNovo (){
      this.novo = !this.novo
    },
  addNovo (){
    
    this.emailErrors = this.aluno.email ? [] : ['Email é obrigatório']
    this.poloErrors = this.aluno.polo_id ? [] : ['Polo é obrigatório']
    this.nomeErrors = this.aluno.nome ? [] : ['Nome é obrigatório']
    this.sobrenomeErrors = this.aluno.sobrenome ? [] : ['Sobrenome é obrigatório']
    this.tipodocumentoErrors = this.aluno.tipo_documento ? [] : ['campo obrigatório']
    this.documentoErrors = this.aluno.doc_oficial ? [] : ['campo obrigatório']
    this.estadocivilErrors = this.aluno.estado_civil ? [] : ['campo obrigatório']
    this.datanascimentoErrors = this.aluno.data_nascimento ? [] : ['campo obrigatório']
    this.profissaoErrors = this.aluno.profissao ? [] : ['campo obrigatório']
    this.escolaridadeErrors = this.aluno.escolaridade ? [] : ['campo obrigatório']
    this.sexoErrors = this.aluno.sexo ? [] : ['campo obrigatório']
    //this.enderecoErrors = this.aluno.endereco ? [] : ['campo obrigatório']
    this.paisErrors = this.aluno.pais_endereco ? [] : ['campo campoobrigatório']
    this.cidadeErrors = this.aluno.cidade ? [] : ['campo obrigatório']
    this.estadoErrors = this.aluno.estado_endereco ? [] : ['campo obrigatório']
    this.napaisErrors = this.aluno.pais_naturalidade ? [] : ['campo obrigatório']
    this.nacidadeErrors = this.aluno.naturalidade ? [] : ['campo obrigatório']
    this.naestadoErrors = this.aluno.estado_naturalidade ? [] : ['campo obrigatório']
    this.cursoErrors = this.aluno.curso ? [] : ['campo obrigatório']
    
      if (!this.formReady) {
        return
      }
      this.$store.dispatch('AddAlunos',this.aluno)
          
                  this.abrirNovo()
                  this.buscar_tipos()
                  this.limpar_aluno()
           
    
    },
    limpar_aluno(){

      this.aluno={
          nome:'',
          sobrenome:'',
          tipo_documento:'',
          doc_oficial:'',
          telefone:'',
          celular:'',
          email:'',
          data_nascimento:'',
          profissao:'',
          escolaridade:'',
          sexo:'',
          estado_civil:'',
          endereco:'',
          numero:'',
          bairro:'',
          cep:'',
          grade_curricular:'',
          nome_escolaridade:'',
          nome_profissao:'',
          cidade:'',
          pais:'',
          naturalidade:'',
          perfil_id: '2',
          polo_id:'',

          curso: {
            id:'',
          },
          
          pais_naturalidade: {
            id:'',
          },
          estado_naturalidade:{
            id:'',
          },
          pais_endereco: {
            id:'',
          },
          estado_endereco:{
            id:'',
          },
          ofertaGradePolo:{
            id:'',
          },
           polo:{
            id:'',
          },

        };

    },
 
  },
}
</script>

<style lang="scss" scoped>

.espaco{
  padding: 5px ; 
}

label{
  color: red  
}


</style>
